import { TiledGameObject } from "src/games/shared/phaserHelpers/HandyTypes";

export class Helper extends Phaser.GameObjects.Sprite {
    id: number;
    name: string;
    isInLine: boolean;
    linePosition: Phaser.Geom.Point;

    constructor(scene: Phaser.Scene, ob: TiledGameObject, id: number) {
        var id = ob.properties[0].value;
        super(scene, ob.x + ob.width / 2, ob.y + ob.height / 2, "assets", "helper" + id);
        this.id = id;
        this.name = ob.name;
        this.isInLine = false;

        this.setInteractive({ useHandCursor: true });
        this.scene.input.setDraggable(this);
        this.scene.add.existing(this);
    }


    setLinePosition(ob: TiledGameObject) {
        this.linePosition = new Phaser.Geom.Point(ob.x + ob.width / 2, ob.y + ob.height / 2);
    }

    putInLine() {
        this.x = this.linePosition.x;
        this.y = this.linePosition.y;
        this.input.enabled = false;
    }

}




// WEBPACK FOOTER //
// ./src/games/FindHelpersGame/objects/Helper.ts